import styled from 'styled-components';
import { palette, theme } from 'styled-tools';

import { minWidth } from '@calm-web/design-system';

export const Wrapper = styled.div`
	color: ${palette('white')};
	display: flex;
	flex-direction: column;
	height: 100%;
`;

export const CountLabel = styled.div`
	align-items: center;
	align-self: center;
	display: flex;
	flex: 1;
	font-size: 144px;
	font-weight: 300;
	justify-content: center;
	margin-top: 64px;
	margin-bottom: 64px !important;
	white-space: nowrap;
`;

export const TimerTransport = styled.div`
	align-items: center;
	bottom: 0;
	display: flex;
	height: 68px;
	left: 0;
	position: fixed;
	right: 0;
	z-index: 10;

	${minWidth('tablet')} {
		height: 100px;
		padding: 32px;
	}
`;

export const TransportContainer = styled.div`
	align-items: center;
	bottom: 40px;
	display: flex;
	flex-direction: column;
	right: 32px;
	left: 32px;
	position: absolute;
	text-align: center;

	${minWidth('tablet')} {
		left: 50%;
		right: auto;
		transform: translateX(-50%);
		width: 560px;
	}

	${minWidth('desktop')} {
		left: calc(50% + ${theme('app.sidebarWidth')});
		transform: translateX(calc(-50% - 120px));
	}
`;

export const TransportIcons = styled.div`
	align-items: center;
	display: flex;
	justify-content: space-between;
	margin: 32px 0;
	width: 100%;
`;
